exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".csas-marker-content-opening-hours {\n  font-weight: 600;\n  color: #0c63a5;\n}\n\n.inlet-wrapp p.csas-mt-10 {\n  margin-top: 10px;\n}\n", ""]);

// exports
